import { render, staticRenderFns } from "./MaintenanceProject.vue?vue&type=template&id=4a562538&scoped=true"
import script from "./MaintenanceProject.vue?vue&type=script&lang=js"
export * from "./MaintenanceProject.vue?vue&type=script&lang=js"
import style0 from "./MaintenanceProject.vue?vue&type=style&index=0&id=4a562538&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a562538",
  null
  
)

export default component.exports